import CatalogHtml, { Props } from 'page/catalog/CatalogHtml'
import { getStandProps } from 'server/stand'

export default function Index(props: Props) {
  if (!props.data) return null
  return <CatalogHtml {...props} />
}

export const getServerSideProps = (context: any) => {
  context.params = {}
  return getStandProps(context)
}
